module.exports = __webpack_public_path__ + "static/media/info.aeba97a9.svg";